import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  typography: {
    fontFamily: `"Segoe UI", Tahoma, Geneva, Verdana, sans-serif`,
  },
});

export default theme;
